import React from "react";
import { CustomButton2, CustomModal } from "../../../../../../components";
import { ShowAllServiceModal } from "../..";
import { useTranslation } from "react-i18next";
import api from "../../../../../../api";
import successHandler from "../../../../../../utils/successHandler";

type Props = {
  service: any;
  isOpen: boolean;
  onClose: () => void;
  allService: any;
};

const RemoveServiceFromDriver: React.FC<Props> = (
  props: Props
): React.ReactElement => {
  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  const { t } = useTranslation();

  const handlesubmit = async () => {
    const result = await api.dele.common.deleteServiceFromDriver(
      props.service._id
    );
    if (result?.CODE === 2099) {
      successHandler(2010);
      props.onClose();
      props.allService.refetch();
    }
  };

  return (
    <CustomModal
      open={props.isOpen}
      onClose={props.onClose}
      label={"ساخت سرویس"}
      minWidth={"25rem"}
    >
      <>
        <div style={{ marginTop: "2rem", fontSize: "14px" }}>
          شما درحال حذف سرویس{" "}
          <strong>
            {props.service?.student?.firstName +
              " " +
              props.service?.student?.lastName}
          </strong>{" "}
          از راننده{" "}
          <strong>
            {" "}
            {props.service?.driver?.firstName +
              " " +
              props.service?.driver?.lastName}
          </strong>{" "}
          هستید
        </div>
        <div style={{ display: "flex", gap: "1rem", marginTop: "2rem" }}>
          <CustomButton2
            title={t("cancel")}
            type="danger"
            onClick={props.onClose}
          />
          <CustomButton2 title={t("submit")} onClick={handlesubmit} />
        </div>
      </>
    </CustomModal>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================
};

export default RemoveServiceFromDriver;
